var map = {
	"./abalone.svg": 68484,
	"./acornsquash.svg": 41010,
	"./alcohol.svg": 96380,
	"./alfalfasprouts.svg": 49475,
	"./almonds.svg": 68898,
	"./apples.svg": 43015,
	"./apricots.svg": 55417,
	"./artichokes.svg": 97291,
	"./arugula.svg": 70749,
	"./asparagus.svg": 99771,
	"./avocados.svg": 78866,
	"./bacon.svg": 73979,
	"./bagel.svg": 2739,
	"./bananas.svg": 72804,
	"./bean.svg": 31750,
	"./beansprouts.svg": 27090,
	"./beef.svg": 39162,
	"./beetgreens.svg": 36092,
	"./beets.svg": 85593,
	"./beverage.svg": 203,
	"./blackberries.svg": 15931,
	"./blondies.svg": 14880,
	"./blueberries.svg": 25294,
	"./bokchoy.svg": 55455,
	"./boysenberries.svg": 8822,
	"./brazilnuts.svg": 86390,
	"./bread.svg": 37512,
	"./broccoli.svg": 52265,
	"./broccolirabe.svg": 26177,
	"./brownies.svg": 30473,
	"./brusselssprouts.svg": 74941,
	"./butter.svg": 24134,
	"./butternutsquash.svg": 31482,
	"./cake.svg": 88584,
	"./candy.svg": 96577,
	"./cantaloupe.svg": 19452,
	"./capers.svg": 22140,
	"./caramel.svg": 15241,
	"./carrots.svg": 17578,
	"./cashews.svg": 37642,
	"./cassava.svg": 55738,
	"./cauliflower.svg": 25659,
	"./celery.svg": 45970,
	"./cheese.svg": 45239,
	"./cherries.svg": 13939,
	"./chicken.svg": 2767,
	"./chickpea.svg": 3466,
	"./chilepeppers.svg": 5270,
	"./chives.svg": 65360,
	"./chocolate.svg": 95212,
	"./chocolatechips.svg": 94543,
	"./chorizo.svg": 25712,
	"./churro.svg": 72417,
	"./cinnamonroll.svg": 13944,
	"./clams.svg": 3104,
	"./clementines.svg": 23369,
	"./cobbler.svg": 28985,
	"./coconutmeat.svg": 81190,
	"./coldcut.svg": 57220,
	"./collardgreens.svg": 30211,
	"./cookies.svg": 35347,
	"./corn.svg": 63106,
	"./cottagecheese.svg": 9410,
	"./crab.svg": 40214,
	"./cranberries.svg": 17116,
	"./crayfish.svg": 95439,
	"./cream.svg": 43648,
	"./cremebrulee.svg": 72297,
	"./crepe.svg": 38987,
	"./croissant.svg": 89414,
	"./cucumber.svg": 87752,
	"./cupcake.svg": 83874,
	"./currants.svg": 58802,
	"./dairy.svg": 9875,
	"./date.svg": 49672,
	"./dough.svg": 79127,
	"./doughnuts.svg": 20599,
	"./dragonfruit.svg": 94719,
	"./driedfruit.svg": 46906,
	"./driedherb.svg": 10011,
	"./eclair.svg": 92648,
	"./edamame.svg": 82474,
	"./eggplant.svg": 29358,
	"./eggs.svg": 86418,
	"./endive.svg": 73375,
	"./englishmuffin.svg": 67729,
	"./escarole.svg": 81568,
	"./fatorsugar.svg": 37960,
	"./fennel.svg": 7236,
	"./figs.svg": 54485,
	"./fish.svg": 76530,
	"./flour.svg": 81838,
	"./food.svg": 90364,
	"./frenchfries.svg": 88251,
	"./frozenyogurt.svg": 1284,
	"./fruit.svg": 8940,
	"./fudge.svg": 75747,
	"./garlic.svg": 97586,
	"./gelatindessert.svg": 31228,
	"./gelato.svg": 96126,
	"./ginger.svg": 79964,
	"./gluten.svg": 1303,
	"./goat.svg": 1885,
	"./gooseberries.svg": 65387,
	"./grain.svg": 86147,
	"./grapefruit.svg": 67625,
	"./grapes.svg": 18708,
	"./greenbeans.svg": 39518,
	"./greenbellpepper.svg": 88120,
	"./greencabbage.svg": 11398,
	"./greenonions.svg": 97501,
	"./groundmeat.svg": 51376,
	"./guavas.svg": 38409,
	"./ham.svg": 62480,
	"./hazelnuts.svg": 52156,
	"./heartofpalm.svg": 94557,
	"./herb.svg": 60249,
	"./honeydew.svg": 41395,
	"./icecream.svg": 75673,
	"./jalapenopeppers.svg": 53839,
	"./jerky.svg": 94377,
	"./jicama.svg": 9717,
	"./kale.svg": 98169,
	"./kiwi.svg": 60416,
	"./kohlrabi.svg": 19766,
	"./lamb.svg": 35548,
	"./leafygreen.svg": 98150,
	"./leeks.svg": 49174,
	"./lemons.svg": 53188,
	"./lentil.svg": 9800,
	"./lentils.svg": 40301,
	"./lettuce.svg": 22268,
	"./limes.svg": 4692,
	"./lobster.svg": 45177,
	"./lychee.svg": 72050,
	"./macadamias.svg": 72217,
	"./mangos.svg": 24841,
	"./mayonnaise.svg": 87860,
	"./milk.svg": 97069,
	"./muffin.svg": 32967,
	"./mussels.svg": 87612,
	"./mustardgreens.svg": 8984,
	"./napacabbage.svg": 7953,
	"./nectarines.svg": 88670,
	"./noodles.svg": 1938,
	"./nut.svg": 41095,
	"./nutmilk.svg": 88550,
	"./octopus.svg": 47641,
	"./oil.svg": 26130,
	"./okra.svg": 19773,
	"./olives.svg": 71808,
	"./onions.svg": 99794,
	"./oranges.svg": 44823,
	"./organmeat.svg": 84088,
	"./other.svg": 51768,
	"./oysters.svg": 92213,
	"./pancakes.svg": 77864,
	"./papaya.svg": 49030,
	"./parsley.svg": 47904,
	"./parsnips.svg": 37420,
	"./passionfruit.svg": 89179,
	"./pasta.svg": 27411,
	"./pea.svg": 14760,
	"./peaches.svg": 63969,
	"./peanutbutter.svg": 50757,
	"./peanuts.svg": 38204,
	"./pears.svg": 9357,
	"./pecan.svg": 19759,
	"./pepper.svg": 57812,
	"./pepperoni.svg": 67742,
	"./persimmon.svg": 92134,
	"./pickle.svg": 89258,
	"./pie.svg": 15272,
	"./pimento.svg": 37338,
	"./pineapple.svg": 47752,
	"./pinenuts.svg": 84810,
	"./pistachios.svg": 42459,
	"./pizza.svg": 31976,
	"./plums.svg": 19823,
	"./pluot.svg": 83070,
	"./pomegranate.svg": 5539,
	"./pork.svg": 70562,
	"./portabellamushrooms.svg": 80205,
	"./potatochips.svg": 19084,
	"./potatognocchi.svg": 51604,
	"./prawns.svg": 65671,
	"./protein.svg": 10447,
	"./proteinpowder.svg": 39364,
	"./pudding.svg": 34157,
	"./pumpkin.svg": 89402,
	"./quark.svg": 53912,
	"./radicchio.svg": 4246,
	"./radishes.svg": 50639,
	"./raisin.svg": 29870,
	"./rambutan.svg": 37968,
	"./raspberries.svg": 62752,
	"./recipe.svg": 82942,
	"./redbellpepper.svg": 40904,
	"./redcabbage.svg": 9942,
	"./redpotato.svg": 72102,
	"./rhubarb.svg": 69002,
	"./ribs.svg": 81654,
	"./rice.svg": 25887,
	"./russetpotato.svg": 12679,
	"./rutabaga.svg": 41749,
	"./salmon.svg": 3218,
	"./sauce.svg": 69747,
	"./sauerkraut.svg": 35123,
	"./scallops.svg": 26885,
	"./seaweed.svg": 33632,
	"./seed.svg": 69911,
	"./serranopepper.svg": 19486,
	"./shallots.svg": 86938,
	"./shellfish.svg": 63046,
	"./shiitakemushrooms.svg": 57005,
	"./sorbet.svg": 97373,
	"./sourcream.svg": 81329,
	"./soy.svg": 9517,
	"./spaghettisquash.svg": 640,
	"./spice.svg": 624,
	"./spinach.svg": 40290,
	"./squid.svg": 55216,
	"./starfruit.svg": 55672,
	"./stock.svg": 94912,
	"./strawberries.svg": 58219,
	"./strudel.svg": 1723,
	"./summersquash.svg": 89660,
	"./sweetener.svg": 44426,
	"./sweetpotato.svg": 24743,
	"./swisschard.svg": 67511,
	"./tangerine.svg": 5511,
	"./taro.svg": 50728,
	"./tilapia.svg": 30580,
	"./tomatillo.svg": 80897,
	"./tomatoes.svg": 16734,
	"./tortilla.svg": 30439,
	"./tuna.svg": 29522,
	"./turkey.svg": 10806,
	"./turnipgreens.svg": 79362,
	"./turnips.svg": 83999,
	"./vegetable.svg": 52479,
	"./vinegar.svg": 90656,
	"./waffles.svg": 1078,
	"./walnuts.svg": 53190,
	"./wasabi.svg": 12579,
	"./watercress.svg": 71417,
	"./watermelon.svg": 18806,
	"./whitemushrooms.svg": 28960,
	"./whitepotato.svg": 95608,
	"./wholegrain.svg": 34250,
	"./wine.svg": 30291,
	"./yams.svg": 17242,
	"./yogurt.svg": 53630,
	"./zucchini.svg": 40091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58301;